import React from 'react'
import { FaFacebook,FaTwitter,FaEnvelope } from 'react-icons/fa';
import logotypeWhite from '../images/images-oakwood-school-logotype-white.svg';

const Footer = () => {
    return (
        <>
            


						<footer class="single__footer">
							<div class="site-color-bands  clear">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
							<div class="single__footer__share">
								<div class="single__footer__share-wrapper">
									<h2 class="single__footer-title">Sharing is Caring</h2>


									<div class="single__footer__social-media-links  a2a_kit share-icons">
										<a class="social-media-link--facebook  a2a_button_facebook"
											title="Share on Facebook" href="https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Fstories.oakwoodschool.org%2F2021%2F01%2F2021-oakwood-summer-programs%2F&linkname=Announcing%20Oakwood%20Summer%20Programs%20in%202021%20%7C%20Oakwood%20Stories&linknote=Email%0A">
												<FaFacebook size='40'/></a>
										<a class="social-media-link--twitter  a2a_button_twitter"
											title="Share on Twitter" href="https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Fstories.oakwoodschool.org%2F2021%2F01%2F2021-oakwood-summer-programs%2F&linkname=Announcing%20Oakwood%20Summer%20Programs%20in%202021%20%7C%20Oakwood%20Stories&linknote=Email%0A">
												<FaTwitter  size='40' /></a>
										<a class="social-media-link--email  a2a_button_email"
											title="Share via email" href="https://www.addtoany.com/add_to/email?linkurl=https%3A%2F%2Fstories.oakwoodschool.org%2F2021%2F01%2F2021-oakwood-summer-programs%2F&linkname=Announcing%20Oakwood%20Summer%20Programs%20in%202021%20%7C%20Oakwood%20Stories&linknote=Email%0A">
                                                <FaEnvelope  size='40'/></a>
									</div>
				
								</div>
							</div>
						</footer>
	
    <footer id="colophon" class="site-footer  clear" role="contentinfo">
        <div class="site-footer__columns">
            <div class="site-footer__column  site-footer__logotype"><a href="https://oakwoodschool.org/"><img
                src={logotypeWhite} alt="Oakwood School logo"/></a></div>
                <nav class="site-footer__column  site-footer__menu-1">
                    <div class="menu-menu-one-container">
                        <ul id="menu-menu-one" class="site-footer__menu">
                            <li id="menu-item-59"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-59"><a
                                
                                    target="_blank" rel="noopener noreferrer"
                                    href="http://www.oakwoodschool.org/about-us">
                                       About Us</a></li>
                            <li id="menu-item-60"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-60"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="http://www.oakwoodschool.org/admission">Admission</a></li>
                            <li id="menu-item-61"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-61"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="http://www.oakwoodschool.org/academics-programs/programs">Academics &amp;
									Programs</a></li>
                            <li id="menu-item-62"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-62"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="http://www.oakwoodschool.org/athletics">Athletics</a></li>
                            <li id="menu-item-63"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-63"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="http://www.oakwoodschool.org/giving-support">Giving &amp; Support</a></li>
                        </ul>
                    </div>
                </nav>
                <nav class="site-footer__column  site-footer__menu-2">
                    <div class="menu-menu-two-container">
                        <ul id="menu-menu-two" class="site-footer__menu">
                            <li id="menu-item-64"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-64"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="https://www.oakwoodschool.org/students">Students</a></li>
                            <li id="menu-item-65"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-65"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="https://www.oakwoodschool.org/parents">Parents</a></li>
                            <li id="menu-item-66"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-66"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="https://www.oakwoodschool.org/alumni">Alumni</a></li>
                            <li id="menu-item-67"
                                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-67"><a
                                    target="_blank" rel="noopener noreferrer"
                                    href="https://www.oakwoodschool.org/campus-pages/faculty/staff">Faculty/Staff</a>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="site-footer__column  site-footer__contact">
                    <ul class="site-footer__menu">
                        <li class="menu-item">
                            <a href="https://www.oakwoodschool.org/about-us/contact-us" target="_blank">Contact</a>
                        </li>
                    </ul>
                    <div class="site-footer__address">
                        <p>11600 Magnolia Blvd</p>
                         <p>North Hollywood, CA 91601-3015</p>
                            <p>Oakwood Secondary School 818-732-3000</p>
                               <p>Oakwood Elementary School 818-732-3500</p>
					</div>
                            <div class="site-footer__copyright">
                                &copy; 2015 &ndash; 2021 Oakwood School. All&nbsp;rights&nbsp;reserved.
					</div>
                     
				</div>
                    </div>
		</footer>
        </>

    )
}

export default Footer
